module.exports = __webpack_public_path__ + "img/1.f32983d2.png";